import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { NestedRoutes } from 'shared/utils';

type ExtraRoute = {
  path: string;
  element: JSX.Element;
  available: boolean;
};

type Props = {
  rootPath: string;
  canCreate?: boolean;
  canEdit?: boolean;
  List: JSX.Element;
  Create?: JSX.Element;
  Edit?: JSX.Element;
  extraRoutes?: ExtraRoute[];
};

export const NestedRouteComponent = ({
  rootPath,
  canCreate,
  canEdit,
  List,
  Edit,
  Create,
  extraRoutes,
}: Props) => {
  return (
    <>
      <Routes>
        <Route index element={List} />
        <Route path={NestedRoutes.List} element={List} />
        {canCreate && Create && <Route path={NestedRoutes.Create} element={Create} />}
        {canEdit && Edit && <Route path={NestedRoutes.Edit} element={Edit} />}
        {extraRoutes
          ?.filter((route) => route.available)
          .map((route) => (
            <Route key={route.path} path={route?.path} element={route?.element} />
          ))}
        <Route
          path='*'
          element={
            <Navigate
              to={{
                pathname: rootPath,
              }}
            />
          }
        />
      </Routes>

      <Outlet />
    </>
  );
};
